/**
 * The identity of a corridor: origin, destination, mode.
 *
 * Corridors are directional and mode-specific, exactly as `RouteDemand` keys
 * them on the backend — Hamburg → Shanghai by SEA is a different market from
 * Shanghai → Hamburg by SEA, and from Hamburg → Shanghai by AIR.
 *
 * Extracted from `DemandLayer` so the layer and the ranked panel join
 * `corridorDemand` against `corridorState` on the *same* string. Two key formats
 * for one concept is how two views of the same data quietly disagree.
 *
 * Pure module: no Vue, no Leaflet, no store.
 */

/**
 * @param {{originNodeId?: string, destinationNodeId?: string, mode?: string}} corridor
 * @returns {string|null} null when any component is missing, so callers can skip
 *   the datum rather than build a key containing "undefined"
 */
export function corridorKey(corridor) {
  if (!corridor?.originNodeId || !corridor.destinationNodeId || !corridor.mode) return null
  return `${corridor.originNodeId}|${corridor.destinationNodeId}|${corridor.mode}`
}
